const anonymous = true // 登录鉴权元信息
const requiresAuth = true // 身份验证元信息
const keepAlive = true // keep-alive 缓存
const Single_Routes = {
    path: '/single/:group',
    name: 'singleFrame',
    props: true,
    component: () => import('@components/Frame.vue'),
    meta: { anonymous, requiresAuth },
    children: [
        // ---------------------------------------------------------------- //
        {
            /**
             * @description: 体育赛事——运动会管理——运动会列表
             */
            path: 'sportsMeet',
            component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetList.vue'),
            breadcrumbName: '运动会管理',
            meta: { requiresAuth, keepAlive }
        },
        {
            /**
             * @description: 体育赛事——运动会管理——运动会列表
             */
            path: 'sportsMeet/add',
            component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetListAdd.vue'),
            breadcrumbName: '新增运动会',
            meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet', keepAlive }
        },
        {
            /**
             * @description: 体育赛事——运动会管理——管理-详情
             */
            path: 'sportsMeet/detail',
            component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetDetail.vue'),
            // props: true,
            breadcrumbName: '管理运动会',
            meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet', keepAlive }
        },
        {
            /**
             * @description: 体育赛事——运动会管理——编排
             */
            path: 'sportsMeet/detail/arrange',
            component: () => import('/src/views/k12/sportsGame/sportsMeet/detailArrangeList.vue'),
            // props: true,
            breadcrumbName: '编排',
            meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet' }
        },
        {
            /**
             * @description: 体育赛事——运动会日程表
             */
            path: 'sportsMeet/detail/calendar',
            component: () => import('/src/views/k12/sportsGame/sportsMeet/calendar.vue'),
            // props: true,
            breadcrumbName: '日程表',
            meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet' }
        },
        {
            /**
             * @description: 体育赛事——运动会管理——风采
             */
            path: 'sportsMeet/demeanor/:meetId',
            component: () => import('/src/views/k12/sportsGame/sportsMeet/sportsMeetListDemeanor.vue'),
            props: true,
            breadcrumbName: '运动风采',
            meta: { requiresAuth, funPath: '/k12/sportsGame/sportsMeet', keepAlive }
        },
        // ---------------------------------------------------------------- //
    ]
}

export default Single_Routes
